import { useContext } from 'react'

import { AlternativeAppContext } from './AlternativeAppContext'

export const useAlternativeAppContext = () => useContext(AlternativeAppContext)
